import React from "react";

import { useIntl } from "react-intl";

import Price from "@mapmycustomers/shared/types/plans/Price";
import Tier from "@mapmycustomers/shared/types/plans/Tier";

import TextWithInfo from "@app/component/typography/TextWithInfo";

import formatPrice from "../../util/formatPrice";
import { DescriptionColumn, PriceColumn, Row } from "../BaseRow";

interface Props {
  daysInCurrentBillingCycle: number;
  licensesAfter: number;
  licensesBefore: number;
  price: Price;
  remainingDays: number;
  selectedTier: Tier;
  switchingToAnnual: boolean;
}

const ProratedPriceRow: React.FC<Props> = ({
  daysInCurrentBillingCycle,
  licensesAfter,
  licensesBefore,
  price,
  remainingDays,
  selectedTier,
  switchingToAnnual,
}) => {
  const intl = useIntl();
  return (
    <Row>
      <DescriptionColumn
        description={intl.formatMessage(
          {
            id: "billing.summary.prorated.description",
            defaultMessage:
              "{count} {count, plural, one {license} other {licenses}} × {price} × ({remainingDays} / {daysInCurrentBillingCycle})",
            description: "Total summary row description on Billing page",
          },
          {
            count: switchingToAnnual ? licensesAfter : licensesAfter - licensesBefore,
            daysInCurrentBillingCycle,
            price: formatPrice(intl, selectedTier.price),
            remainingDays,
          }
        )}
        title={
          <TextWithInfo
            info={intl.formatMessage({
              id: "billing.summary.prorated.title.hint",
              defaultMessage:
                "Prorated Price is a reduced price reflecting unused time in the current billing cycle.",
              description: "Hint for prorated price summary row on Billing page",
            })}
          >
            {intl.formatMessage({
              id: "billing.summary.prorated.title",
              defaultMessage: "Prorated Price for New Users",
              description: "Prorated price summary row on Billing page",
            })}
          </TextWithInfo>
        }
      />
      <PriceColumn>{formatPrice(intl, price, 2)}</PriceColumn>
    </Row>
  );
};

export default ProratedPriceRow;
